import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const BatterySalesService = {
  getInventory: async (data) => {
    const response = await authInstance
      .get(`${url}/battery/list/?` + new URLSearchParams(data))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  getApplicative: async (data) => {
    const response = await authInstance
      .get(`${url}/battery/listApplicative/?` + new URLSearchParams(data))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  setInventory: async (data) => {
    const response = await authInstance
      .post(`${url}/battery/setInventory/`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
